import * as Storage from 'utils/local-storage'

export const hasSeenWelcomeModal = async (): Promise<boolean | undefined> => {
    if (typeof window !== 'undefined') {
        return (await Storage.get(Storage.Keys.WelcomeModalSeen)) == 'true'
    }
}

export const setWelcomeModalSeen = async (value: boolean) => {
    if (typeof window !== 'undefined') {
        return await Storage.set(Storage.Keys.WelcomeModalSeen, value.toString())
    }
}
